export const LEARNED_AUTO_FILL_LIBRARY_STORAGE_KEY = 'pipeex.learnedAutoFillLibrary.v1';
export const LEARNED_AUTO_FILL_LIBRARY_KIND = 'pipeex-key-library';
export const LEARNED_AUTO_FILL_LIBRARY_VERSION = 1;
export const MAX_LEARNED_LIBRARY_FILE_BYTES = 1024 * 1024;
export const MAX_LEARNED_LIBRARY_ENTRIES = 5000;
export const MAX_LEARNED_PATTERN_KEYS = 32;
export const MAX_LEARNED_PATTERN_KEY_LENGTH = 128;

export const MAX_LEARNED_FAMILY_NAME_LENGTH = 512;
export const MAX_LEARNED_VALUE_LENGTH = 256;

export interface LearnedAutoFillValuesV1 {
  objectType: string;
  skey: string;
  end1?: string;
  end2?: string;
  end3?: string;
  end4?: string;
}

export interface LearnedAutoFillPatternV1 {
  id: string;
  sourceFamilyName: string;
  requiredKeys: string[];
  values: LearnedAutoFillValuesV1;
  updatedAt: string;
}

export interface LearnedAutoFillLibraryDocumentV1 {
  contract: typeof LEARNED_AUTO_FILL_LIBRARY_KIND;
  schemaVersion: typeof LEARNED_AUTO_FILL_LIBRARY_VERSION;
  exportedAt: string;
  entries: LearnedAutoFillPatternV1[];
}

export interface LearnedAutoFillMatch extends LearnedAutoFillValuesV1 {
  confidence: number;
  matchedPatternId: string;
  matchedKeywords: string[];
}

export type LearnedAutoFillMergeStatus = 'new' | 'unchanged' | 'conflict';

export interface LearnedAutoFillMergeItem {
  incoming: LearnedAutoFillPatternV1;
  existing?: LearnedAutoFillPatternV1;
  status: LearnedAutoFillMergeStatus;
}

export type LearnedAutoFillLibraryParseResult =
  | { ok: true; document: LearnedAutoFillLibraryDocumentV1 }
  | { ok: false; error: string };
